<template>
  <vue-easy-lightbox ref="lightbox" :visible="open" :imgs="paths" :index="index" @hide="hideHandler"/>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'
import { mapActions, mapState } from 'vuex'
import { map, path } from 'ramda'

export default {
  name: 'ImageLightbox',
  components: { VueEasyLightbox },
  data() {
    return {
      index: 0,
    }
  },
  watch: {
    open() {
      if (this.open) {
        this.index = 0
      }
    },
  },
  computed: {
    ...mapState(
      {
        open: path(['lightbox', 'open']),
        images: path(['lightbox', 'images']),
      },
    ),
    paths() {
      return map(path(['src']), this.images || [])
    },
  },
  methods: {
    ...mapActions(
      {
        close: 'lightbox/close',
        clearImages: 'lightbox/clearImages',
      },
    ),
    hideHandler() {
      this.close()
      this.$nextTick(this.clearImages)
    },
  },
}
</script>
